import dayjs from 'dayjs';

export const dayjsToString = (value: any): string =>
  dayjs.isDayjs(value) ? value.toISOString() : value;
